module.exports = __webpack_public_path__ + "static/media/unselectedrightnew.ed68c662.svg";